import React, { useState } from "react";

const TableRow = ({
  row,
  level,
  originalValue,
  onUpdate,
  calculateVariance,
  renderChildren,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleAllocationPercentage = () => {
    const percentage = parseFloat(inputValue);
    if (!isNaN(percentage)) {
      onUpdate(row.id, percentage, true);
      setInputValue("");
    }
  };

  const handleAllocationValue = () => {
    const value = parseFloat(inputValue);
    if (!isNaN(value) && value >= 0) {
      onUpdate(row.id, value, false);
      setInputValue("");
    }
  };

  const variance = calculateVariance(row.value, originalValue);
  const indent = level * 20;
  const isParent = row.children && row.children.length > 0;

  return (
    <>
      <tr
        className={`row-level-${level} ${
          isParent ? "parent-row" : "child-row"
        }`}
      >
        <td style={{ paddingLeft: `${indent + 10}px` }}>
          {level > 0 && "-- "}
          {row.label}
        </td>
        <td>{row.value.toFixed(2)}</td>
        <td>
          <input
            type="number"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Enter value"
            className="input-field"
          />
        </td>
        <td>
          <button
            onClick={handleAllocationPercentage}
            className="btn btn-percentage"
            disabled={!inputValue}
          >
            Allocation %
          </button>
        </td>
        <td>
          <button
            onClick={handleAllocationValue}
            className="btn btn-value"
            disabled={!inputValue}
          >
            Allocation Val
          </button>
        </td>
        <td
          className={
            variance > 0
              ? "positive-variance"
              : variance < 0
              ? "negative-variance"
              : ""
          }
        >
          {variance.toFixed(2)}%
        </td>
      </tr>
      {renderChildren && renderChildren()}
    </>
  );
};

export default TableRow;
